import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { useGetDefaultTenantTimeRange } from '@modules/common/hooks';
import { isEmptyWhereClause } from '@modules/common/utils';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { useFeedStore } from '@modules/feed/store/feedStore';
import { FeedActionType } from '@modules/feed/store/searchActionType';
import { FeedDashboardFilters } from '@modules/feed/store/types';
import {
  getCombinedFeedAndDashboardFilters,
  getSearchQueryFromMetadata,
} from '@modules/feed/utils';
import { useEffect } from 'react';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';

export const useUpdateFeedQueryStateForGlobalFilters = () => {
  const defaultTimeRange = useGetDefaultTenantTimeRange();
  const { data: sourceDetailsMap } = useGetSourceDetailsMap();

  const dispatch = useFeedStore(({ dispatch }) => dispatch);
  const feedMetadata = useAnalysisStore(({ metadata }) => metadata);
  const eqlProperties = useAnalysisStore(
    ({ context }) => context?.eql?.properties,
  );

  const globalFilterDuration = useDashboardStore(({ query }) => query.duration);
  const globalFilterWhereClause = useDashboardStore(
    ({ query }) => query.whereClause,
  );

  useEffect(() => {
    const isGlobalFiltersApplied =
      !!globalFilterDuration || !isEmptyWhereClause(globalFilterWhereClause);

    const updatedDashboardFilters: FeedDashboardFilters | null =
      isGlobalFiltersApplied
        ? {
            duration: globalFilterDuration,
            whereClause: !isEmptyWhereClause(globalFilterWhereClause)
              ? globalFilterWhereClause
              : undefined,
          }
        : null;

    const query = getSearchQueryFromMetadata({
      metadata: feedMetadata,
      getDurationField: true,
      defaultTimeRange,
      eqlProperties,
      sourceDetailsMap,
    });

    dispatch({
      type: FeedActionType.SET_QUERY,
      payload: query,
    });

    dispatch({
      type: FeedActionType.SET_VISUAL,
      payload: {
        dashboardFilters: updatedDashboardFilters,
        feedAndDashboardFilters: getCombinedFeedAndDashboardFilters({
          primaryQuery: query,
          dashboardFilters: updatedDashboardFilters,
        }),
      },
    });
  }, [
    defaultTimeRange,
    dispatch,
    eqlProperties,
    feedMetadata,
    globalFilterDuration,
    globalFilterWhereClause,
    sourceDetailsMap,
  ]);
};
